export const admin = {
  dashboard: {
    title: "Irányítópult",
    welcomeBack: "Üdv újra itt",
    setUpYourProfile: "Állítsd be a profilod",
    stats: {
      balance: "Egyenleg",
      sales: "Eladások",
      views: "Megtekintések",
      followers: "Követők",
    },
    callToAction: "Mit szeretnél ma csinálni?",
    createContent: "Új tartalom létrehozása",
    viewAnalytics: "Elemzések megtekintése",
    recentPurchases: "Legutóbbi vásárlások",
    viewAllPurchases: "Összes vásárlás megtekintése",
    setupSteps: {
      title: "Profilbeállítás",
      completeYourProfile: "Profilod kitöltése",
      connectSocial: "Közösségi fiók csatolása",
      createYourFirstProduct: "Első terméked létrehozása",
      getReadyToSell: "Felkészülés az értékesítésre"
    },
    v2: {
      hero: {
        morning: "Jó reggelt",
        afternoon: "Szia",
        evening: "Jó estét",
        liveBadge: "Élő",
        loading: "Készítjük a mai napod összefoglalóját…",
        summary: "Ma {bookings} foglalásod van, várható bevétel {revenue} Ft, és {messages} olvasatlan üzenet vár rád.",
        chips: {
          bookings: "foglalás ma",
          credits: "AI hitel",
          expected: "várható"
        },
        actions: {
          newBooking: "Új foglalás",
          newProduct: "Új termék",
          aiPost: "AI poszt írása"
        }
      },
      kpi: {
        labels: {
          revenue: "Bevétel (30 nap)",
          bookings: "Foglalások (hét)",
          customers: "Új ügyfelek",
          conversion: "Konverzió"
        }
      },
      schedule: {
        title: "Mai menetrend",
        subtitle: "Foglalások, workshopok és szabad slotok egy pillantásra",
        tabs: { today: "Ma", tomorrow: "Holnap", week: "Hét" },
        addSlot: "Új időpont",
        break: "Szünet",
        legend: {
          booking: "Foglalás",
          private: "Privát óra",
          workshop: "Workshop",
          break: "Szünet"
        }
      },
      ai: {
        title: "AI asszisztens teendők",
        subtitle: "Javaslatok, amik egy kattintással mehetnek",
        pending: "függőben",
        emptyState: "Mindennel végeztél — szép munka!",
        accept: "Elfogadás",
        dismiss: "Elvetés",
        ago: ""
      },
      trend: {
        title: "Bevétel és foglalások",
        last30: "elmúlt 30 nap",
        bookings: "foglalás",
        tabs: { revenue: "Bevétel", bookings: "Foglalás" }
      },
      topProducts: {
        title: "Top termékek",
        subtitle: "Heti eladás szerint rangsorolva",
        units: "db"
      },
      leads: {
        title: "Új ügyfelek",
        subtitle: "Honnan érkeznek a friss érdeklődők",
        live: "Élő",
        ago: "ezelőtt",
        sources: {
          instagram: "Instagram",
          website: "Weboldal",
          referral: "Ajánlás",
          google: "Google"
        }
      },
      funnel: {
        title: "Foglalási tölcsér",
        subtitle: "Instagramtól a megerősített foglalásig",
        conversion: "konverzió"
      },
      community: {
        newReview: "Új értékelés",
        newMessage: "Új üzenet",
        unreadInstagram: "olvasatlan DM",
        hoursAgo: "órája",
        minutesAgo: "perce"
      },
      setup: {
        title: "Első lépések",
        continue: "Folytasd"
      }
    }
  },
  locations: {
    types: {
      online: "Online",
      in_person: "Személyes"
    }
  },
  navigation: {
    dashboard: "Irányítópult",
    content: "Tartalom",
    orders: "Rendelések",
    customers: "Ügyfelek",
    messages: "Üzenetek",
    settings: "Beállítások",
    logout: "Kijelentkezés",
    packages: "Csomagok",
    groupCalls: "Csoportos hívások",
    workshops: "Workshopok",
    finances: "Pénzügyek",
    reviews: "Értékelések",
    aiBuilder: "AI Builder",
    interactiveData: "Interaktív adatok",
    pageSetup: "Oldal beállítása",
  },
  workshops: {
    title: "Workshop kezelés",
    activeWorkshops: "Aktív workshopok",
    completedWorkshops: "Befejezett workshopok",
    noActiveWorkshops: "Nincs aktív workshopod.",
    noCompletedWorkshops: "Nincs befejezett workshopod.",
    createWorkshop: "Új workshop létrehozása",
    editWorkshop: "Workshop szerkesztése",
    deleteWorkshop: "Workshop törlése",
    details: "Részletek",
    location: "Helyszín",
    onlineEvent: "Online esemény",
    physicalEvent: "Fizikai esemény",
    online: "Online",
  },
  groupCalls: {
    title: "Videóhívásaid",
    groupCalls: "Csoportos videóhívások",
    privateCalls: "Privát videóhívások",
    activeGroupCalls: "Aktív csoportos hívásaid",
    expiredGroupCalls: "Lejárt csoportos hívásaid",
    activePrivateCalls: "Aktív privát hívásaid",
    expiredPrivateCalls: "Lejárt privát hívásaid",
    noActiveGroupCalls: "Nincs aktív csoportos hívásod.",
    noExpiredGroupCalls: "Nincs lejárt csoportos hívásod.",
    noActivePrivateCalls: "Nincs aktív privát hívásod.",
    noExpiredPrivateCalls: "Nincs lejárt privát hívásod."
  },
  packages: {
    title: "Csomagjaid",
    newPackage: "Új csomag létrehozása",
    editPackage: "Csomag szerkesztése",
    search: "Csomag keresése",
    table: {
      coverImage: "Borítókép",
      title: "Cím",
      price: "Ár",
      uploadDate: "Feltöltés dátuma",
      salesCount: "Eladások",
      status: "Állapot",
      actions: "Műveletek"
    }
  },
  orders: {
    title: "Rendelések",
    activeOrders: "Aktív videó rendelések",
    completedOrders: "Teljesített és elutasított videó rendelések",
    noActiveOrders: "Nincs aktív videó rendelés.",
    noCompletedOrders: "Nincs teljesített vagy elutasított videó rendelés.",
    details: "Rendelés részletei",
    uploadVideo: "Videó feltöltése",
    acceptOrder: "Rendelés elfogadása",
    rejectOrder: "Rendelés elutasítása",
    completeOrder: "Rendelés teljesítése",
    customer: "Vásárló",
    price: "Ár",
    status: "Státusz",
    deadline: "Határidő",
    type: "Típus",
    description: "Leírás",
    actions: "Műveletek"
  },
  content: {
    title: "Tartalmaid",
    newContent: "Új tartalom",
    editContent: "Tartalmad szerkesztése",
    search: "Keresés"
  },
  settings: {
    title: "Beállításaid",
    profile: {
      title: "Profil beállítások",
      profileImage: "Profilkép",
      coverImage: "Borítókép",
      name: "Neved",
      username: "Felhasználónév",
      email: "E-mail cím",
      bio: "Rövid bemutatkozás",
      categories: "Kategóriák",
      save: "Mentés",
      socialMedia: "Közösségi média linkek"
    },
    billing: {
      title: "Számlázás",
      bankAccount: "Bankszámlaszám",
      taxId: "Adószám",
      companyName: "Cégnév",
      billingAddress: "Számlázási cím",
      save: "Mentés"
    },
    socialMedia: {
      title: "Közösségi média",
      instagram: "Instagram",
      tiktok: "TikTok",
      youtube: "YouTube",
      facebook: "Facebook",
      twitter: "Twitter",
      save: "Mentés"
    },
    buttons: {
      save: "Változtatások mentése",
      saving: "Mentés...",
      cancel: "Mégse"
    },
    toast: {
      success: {
        title: "Beállítások mentve",
        description: "A beállításaid sikeresen frissítve lettek."
      },
      error: {
        title: "Hiba",
        description: "Nem sikerült menteni a beállításokat. Kérjük, próbáld újra."
      }
    }
  },
  messages: {
    title: "Kérdéseid"
  },
  customers: {
    title: "Vásárlóid",
    search: "Vásárló keresése",
    filter: "Szűrés",
    activeCustomers: "Aktív vásárlók",
    noActiveCustomers: "Nincs aktív vásárló.",
    previousCustomers: "Korábbi vásárlók",
    noPreviousCustomers: "Nincs korábbi vásárló.",
    table: {
      name: "Név",
      email: "E-mail",
      date: "Regisztráció dátuma",
      purchases: "Vásárlások",
      amount: "Összeg",
      actions: "Műveletek"
    },
    details: {
      title: "Vásárló adatai",
      personalInfo: "Személyes adatok",
      name: "Név",
      email: "E-mail",
      phone: "Telefonszám",
      registrationDate: "Regisztráció dátuma",
      purchases: "Vásárlások",
      purchaseDate: "Vásárlás dátuma",
      product: "Termék",
      price: "Ár",
      status: "Állapot",
      total: "Összesen",
      close: "Bezárás"
    }
  },
  finances: {
    title: "Pénzügyeid és egyenleged",
    payoutsList: "Kifizetéseid listája",
    pendingOrders: "Függőben lévő rendelések",
    payoutId: "Kifizetés ID",
    date: "Dátum",
    amount: "Összeg",
    status: "Státusz",
    reference: "Referencia",
    orderId: "Rendelés ID",
    customer: "Ügyfél",
    orderType: "Rendelés típusa",
    orderAmount: "Összeg",
    orderDate: "Dátum",
    includedOrders: "Kifizetésben szereplő rendelések",
    errors: {
      balanceError: "Hiba történt az egyenleged betöltése közben",
      payoutsError: "Hiba történt a kifizetéseid betöltése közben",
      orderPaymentsError: "Hiba történt a rendelések kifizetési adatainak betöltése közben",
      statsError: "Hiba történt a statisztikáid betöltése közben"
    },
    balance: {
      title: "Egyenleged",
      description: "Jelenlegi egyenleged",
      pending: "Függőben lévő összeg",
      pendingOrders: "függőben lévő rendelés",
      nextPayout: "Következő kifizetés",
      explanation: "Hogyan számoljuk az egyenleged?"
    },
    stats: {
      totalRevenue: "Összes bevétel",
      thisMonth: "Ebben a hónapban",
      lastMonth: "Előző hónapban"
    },
    tokenPurchases: {
      title: "Token vásárlások",
      description: "A token vásárlásaid áttekintése",
      package: "Csomag",
      tokens: "token",
      date: "Dátum",
      amount: "Összeg",
      status: "Státusz",
      statuses: {
        completed: "Teljesítve",
        pending: "Függőben",
        failed: "Sikertelen"
      },
      noData: "Még nincs token vásárlásod"
    }
  },
  pageSetup: {
    title: "Oldal beállítások",
    preview: "Előnézet",
    sections: {
      title: "Oldalak",
      add: "Új szakasz hozzáadása",
      reorder: "Szakaszok átrendezése"
    },
    theme: {
      title: "Témák",
      primaryColor: "Elsődleges szín",
      mode: "Mód",
      light: "Világos",
      dark: "Sötét"
    },
    save: "Mentés"
  },
  reviews: {
    title: "Értékelések",
    listTitle: "Értékelések listája",
    idColumn: "Értékelés ID",
    userColumn: "Felhasználó",
    typeColumn: "Típus",
    ratingColumn: "Értékelés",
    dateColumn: "Dátum",
    actionsColumn: "Műveletek",
    detailsButton: "Részletek",
    detailsTitle: "Értékelés részletei",
    rating: "Értékelés",
    textReview: "Szöveges értékelés",
    sending: "Küldés...",
    replyWithEmoji: "Válasz emoji-val",
    reporting: "Jelentés...",
    report: "Jelentés"
  },
  interactiveData: {
    title: "Interaktív adatok"
  },
  aiBuilder: {
    title: "AI Asszisztens",
    inputPlaceholder: "Írd le a válaszod...",
    thinking: "Gondolkozom...",
    send: "Küldés"
  },
  registration: {
    backToEditing: "Vissza a szerkesztéshez"
  },
  tokens: {
    balance: "Token egyenleg",
    used: "Felhasznált",
    total: "Összesen",
    buyTokens: "Token vásárlás",
    buyMore: "További tokenek vásárlása",
    perMonth: "/hó",
    packages: {
      basic: {
        name: "Alap csomag",
        tokens: "10,000 token",
        price: "9,990 Ft"
      },
      professional: {
        name: "Professzionális csomag",
        tokens: "50,000 token",
        price: "39,990 Ft"
      },
      enterprise: {
        name: "Vállalati csomag",
        tokens: "200,000 token",
        price: "129,990 Ft"
      }
    },
    dialog: {
      title: "Token vásárlás",
      description: "Válaszd ki a számodra megfelelő csomagot",
      selectPackage: "Csomag kiválasztása",
      cancel: "Mégse",
      purchase: "Vásárlás"
    }
  }
};
